const GET_CORE_SKILL = 'GET_CORE_SKILL';

export {
    GET_CORE_SKILL,
}
